// gkc_hash_code : 01GPFQ2BY4JCG0W281FKCRX39R

import { useTranslation } from 'react-i18next';
import CollectRouteTemplate from 'components/templates/CollectRouteTemplate';
import ConfirmSelectEmissionItemsContent from 'components/organisms/ConfirmSelectEmissionItems';
import { Path } from 'routes';
import { getApiPath, objectFetch } from 'util/commons';
import { useHistory, useLocation, useParams } from 'react-router-dom';
import CollectRouteQRScanHeader from 'components/organisms/CollectRouteQRScanHeader';
import styles from './CollectSelectEmissionItems.module.scss';
import { useState } from 'react';

const ConfirmSelectEmissionItems = () => {
  const { t } = useTranslation();
  const { routeId, siteId } = useParams<{ routeId: string; siteId: string }>();
  const { state } = useLocation();
  const [hasCollectedSuccess, setHasCollectedSuccess] = useState(false);
  const history = useHistory();

  return (
    <CollectRouteTemplate
      showViewModeSwitch={false}
      h1={t('collects.title')}
      prevFunction={() => {
        history.push(
          `${getApiPath(Path.routeSiteSelection, {
            routeId: objectFetch(state, 'routeId') || routeId,
          })}${window.location.search}`,
          {
            refreshSites: hasCollectedSuccess || objectFetch(state, 'routeId'),
          }
        );
      }}
      leftComponent={<CollectRouteQRScanHeader siteId={siteId} />}
      classNames={{
        actions: styles.actionBar,
      }}
    >
      <ConfirmSelectEmissionItemsContent
        setHasCollectedSuccess={setHasCollectedSuccess}
      />
    </CollectRouteTemplate>
  );
};

export default ConfirmSelectEmissionItems;
